import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/UI/Typography/Text';
import { ModalWrapper, Title } from './styles';
import { Close } from '@/components/Icon';
import { Modal } from '@mui/material';
import { Box } from '@/layout';

interface DisclaimerModalProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const CouponModal = ({ showModal, setShowModal }: DisclaimerModalProps) => {
  // @ts-ignore
  const { t } = useTranslation();

  // 關閉時將setResponse設為false
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <Modal
      open={showModal}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableEnforceFocus
    >
      <ModalWrapper>
        <Close.ButtonClose onClick={handleClose}>
          <Close.CloseSVG />
        </Close.ButtonClose>
        <Box width="100%" padding={'10px 20px'}>
          <Title>{t('pages.dealDetail.manageFiles.contractTemplates.content.Disclaimer.title')}</Title>
          <Text>{t('pages.dealDetail.manageFiles.contractTemplates.content.Disclaimer.firstPart')}</Text>
          <br />
          <br />
          <Text>{t('pages.dealDetail.manageFiles.contractTemplates.content.Disclaimer.secondPart')}</Text>
          <br />
          <br />
          <Text>{t('pages.dealDetail.manageFiles.contractTemplates.content.Disclaimer.thirdPart')}</Text>
          <br />
          <br />
          <Text fontWeight={'bold'}>{t('pages.dealDetail.manageFiles.contractTemplates.download')}</Text>
          <Text fontWeight={'bold'}>{t('pages.dealDetail.manageFiles.contractTemplates.note')}</Text>
        </Box>
      </ModalWrapper>
    </Modal>
  );
};

export default CouponModal;
